import { create } from 'zustand';

export type EntityFeatures = {
  customFields: boolean;
  attachments: boolean;
  projectLinks: boolean;
  audit: boolean;
  reportable: boolean;
  navSearchable: boolean;
  // True only for entities some route/service actually calls
  // automation.applyEntityRules(...) for — see src/services/entity-registry.js
  // FEATURE_KEYS comment. Independent of customFields (task 8fix).
  automation: boolean;
};

// One entry per entity, mirrors src/services/entity-registry.js (serialized form).
export type EntityMeta = {
  key: string;
  table: string;
  label: string;
  labelPlural: string;
  routes: { list: string | null; detail: string | null };
  rbacNode: string | null;
  numberField: string | null;
  attachmentType: string | null;
  attachmentMiddleware: string;
  projectLinkType: string | null;
  customFieldEntity: string | null;
  navSection: string | null;
  navKeywords: string | null;
  features: EntityFeatures;
};

type MetadataState = {
  registry: EntityMeta[];
  ready: boolean;
  setRegistry: (r: EntityMeta[]) => void;
  setReady: (v: boolean) => void;
  clear: () => void;
};

export const useMetadataStore = create<MetadataState>((set) => ({
  registry: [],
  ready: false,
  setRegistry: (registry) => set({ registry }),
  setReady: (v) => set({ ready: v }),
  clear: () => set({ registry: [], ready: false }),
}));
